import { defineComponent as _defineComponent } from 'vue'
import { Delete, Edit } from '@element-plus/icons-vue';
import { onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import jobsApi from '@/api/jobs';
import tablePager from '@/components/table-pager.vue';
import i18n from '@/i18n';
import { Search } from '@element-plus/icons-vue';
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import ClipboardJS from 'clipboard'


const __default__ = {
  name: 'jobs-manage',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = i18n.global;

const pager = ref();
let count = ref(0);
let tableData = ref([]);
let editMangaDialog = ref(false);
let keyWord = ref('');
let payload = ref('');
let form = reactive({
  mangaId: '',
  mangaName: '',
  mangaPath: '',
  mangaCover: '',
  browseType: '',
  removeFirst: '',
  direction: 0,
});

const formInit = {
  mangaId: '',
  mangaName: '',
  mangaPath: '',
  mangaCover: '',
  browseType: 'flow',
  removeFirst: 0,
  direction: 1,
};

onMounted(() => {
  load_table();
})


/***
 * 关闭弹窗
 */
function dialog_close() {
  editMangaDialog.value = false;
}

/**
 * 加载表格数据
 */
async function load_table(page = 1, pageSize = 10) {
  const res = await jobsApi.get(page, pageSize, '', keyWord.value);
  count.value = res.count;
  tableData.value = res.list;
}
/**
 * 重载数据 页码不变
 */
function reload_table() {
  pager.value.reload_page();
}
/**
 * 编辑漫画
 * @param index
 * @param row
 */
function edit_manga(index: number, row: any) {
  editMangaDialog.value = true;
  payload.value = JSON.stringify(JSON.parse(row.payload), null, 2);
}

/**
 * 执行修改请求
 */
async function copy_payload() {
  const clipboard = new ClipboardJS('#copy-btn', {
    text() {
      return payload.value
    }
  })
  clipboard.on('success', () => {
    ElMessage.success('复制成功')
  })
  clipboard.on('error', () => {
    ElMessage.error('复制失败')
  })
}

/**
 * 删除漫画
 * */
async function delete_manga(index: number, row: any) {
  ElMessageBox.confirm(
    t('jobsManage.deleteConfirm'),
    t('mangaManage.deleteTitle'),
    {
      type: 'warning',
    }
  )
    .then(async () => {
      const res = await jobsApi.delete(row.id);

      if (res.code === 0) {
        reload_table();
      }
    })
    .catch(() => { });
}

const __returned__ = { t, pager, get count() { return count }, set count(v) { count = v }, get tableData() { return tableData }, set tableData(v) { tableData = v }, get editMangaDialog() { return editMangaDialog }, set editMangaDialog(v) { editMangaDialog = v }, get keyWord() { return keyWord }, set keyWord(v) { keyWord = v }, get payload() { return payload }, set payload(v) { payload = v }, get form() { return form }, set form(v) { form = v }, formInit, dialog_close, load_table, reload_table, edit_manga, copy_payload, delete_manga, get Delete() { return Delete }, get Edit() { return Edit }, tablePager }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})